export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10898.75e5fcb9.jpg";